import { useMemo } from "react";
import { useLists } from "@/context/ListsContext";
import { COMPANY_LOGOS } from "@/lib/companies";

/**
 * Shared dropdown-option builder used by every workflow page.
 * Memoized so option arrays don't churn identity on every render.
 */
export function useDropdownOptions() {
  const { lists, customers } = useLists();

  return useMemo(() => {
    const companyNames = lists.companies || ["JTD of CHS", "Sweet CHS"];
    return {
      owners: lists.owners || [],
      priorities: lists.priorities || ["High", "Normal", "Low"],
      jobStatuses: lists.job_statuses || [],
      taskStatuses: lists.task_statuses || [],
      artworkStatuses: lists.artwork_statuses || [],
      websiteStatuses: lists.website_statuses || [],
      websiteCategories: lists.website_categories || [],
      sendoffTypes: lists.sendoff_types || [],
      sendoffStatuses: lists.sendoff_statuses || [],
      quoteStatuses: lists.quote_statuses || [],
      customerOpts: customers.map((c) => ({ label: c.name, value: c.id })),
      companyOpts: companyNames.map((name) => ({ label: name, value: name, icon: COMPANY_LOGOS[name] })),
    };
  }, [lists, customers]);
}
